module.exports = __webpack_public_path__ + "img/main-banner-mobile.b845ce2.png";